import * as React from 'react'
import { ServerStore, ConnectionStatus } from '../../stores/ServerStore'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { Row } from 'antd-v4'
import { COLORS } from '../../constants/Colors'
import { BLAZE_COMPANY } from '../../constants/general'

interface InjectedProps {
  serverStore?: ServerStore
}

export const ServerStatus = inject('serverStore')(
  observer((props: InjectedProps) => {
    const backgroundColor =
      props.serverStore!.isConnectedToServer === ConnectionStatus.CONNECTED
        ? COLORS.green500
        : COLORS.ACTIONS.danger

    const status =
      props.serverStore!.isConnectedToServer === ConnectionStatus.CONNECTED
        ? 'Online'
        : props.serverStore!.isInternetConnected
        ? `${BLAZE_COMPANY} offline`
        : 'No internet'

    return (
      <Row className='d-flex align-items-baseline pl-4 pb-4'>
        <div
          className='mr-2'
          style={{
            width: 10,
            height: 10,
            borderRadius: 10,
            backgroundColor,
          }}
        />

        <span
          style={{
            color: 'var(--white)',
            opacity: 0.8,
          }}
        >
          {status}
        </span>
      </Row>
    )
  }),
)
